import { PAGE_REQUEST } from 'store/app/actions';

import { types } from './actions';

const initialState = {
  isOpen: false,
  managedIntegrationUuid: null,
  webhookUuid: null,
  isEditing: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case PAGE_REQUEST:
      return initialState;
    case types.CLOSE:
      return {
        ...state,
        isOpen: false,
      };
    case types.OPEN:
      return {
        ...state,
        isOpen: true,
        managedIntegrationUuid: payload.managedIntegrationUuid,
        webhookUuid: payload.webhookUuid,
        isEditing: payload.isEditing,
      };

    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.settings.integrations.webhookCreateEditDrawer;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsEditing = (state) => getScope(state).isEditing;

export const getManagedIntegrationUuid = (state) =>
  getScope(state).managedIntegrationUuid;

export const getWebhookUuid = (state) => getScope(state).webhookUuid;
